import taskFormElemAssetListDef from './elemAssetList';
import taskFormElemMultipleChoiceDef from './elemMultipleChoice';
import taskFormElemNumberDef from './elemNumber';
import taskFormElemStringDef from './elemString';
import taskFormElemBooleanDef from './elemBoolean';
import { TpTaskFormElemDef } from './interfaces';
import { getUserError } from '../../../components/miscUtils';

// List of all types of elements available in a task form
export const taskFormElemDefs = [
  taskFormElemStringDef,
  taskFormElemNumberDef,
  taskFormElemMultipleChoiceDef,
  taskFormElemAssetListDef,
  taskFormElemBooleanDef,
];

const elemMap: { [type: string]: TpTaskFormElemDef } = {};
for (const elem of taskFormElemDefs) elemMap[elem.type] = elem;

export function taskFormElemFactory(type: string) {
  if (!elemMap[type]) throw getUserError(`Invalid Task form element type: ${type}`);
  return elemMap[type];
}
